// extracted by mini-css-extract-plugin
export default {"Skeleton":"Skeleton3vPVkQcpdzxg","Skeleton_box":"Skeleton_box28Y-Mj4bI5wo","Skeleton_circle":"Skeleton_circle2iVk5BitcMe-"};